


import { AccountCircle, ArrowBack, AttachMoney, Category, Email, Facebook, Instagram, LocationOn, Note, PersonAdd, Phone, YouTube } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton'; // Import the Skeleton component
import 'react-loading-skeleton/dist/skeleton.css'; // Import the styles for the Skeleton
import { useLocation, useNavigate } from 'react-router-dom';
import CampaignsModal from './Campaignmodel';
import Navbar from './Navbar';

const InfluencerDetails3 = () => {
  const location = useLocation();
  const { userData } = location.state || {};
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); // Show loader for 1 second
    return () => clearTimeout(timer);
  }, []);


    const handleClick = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };
    // Check screen width for responsiveness
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 700);
      };
  
      handleResize(); // Check initial size
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  if (!userData) {
    return <div>No data found</div>;
  }

  const handleInviteClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleBackClick = () => {
    navigate(-1); // Navigate to the previous screen
  };

  return (
    <div className="flex h-screen mb-0">
      {/* Navbar with higher z-index */}
      <div className="text-white fixed top-0 left-0 bottom-0 z-20">
        <Navbar />
      </div>

      {/* Main content */}
      <div className="ml-0 w-screen sm:ml-0 h-screen pt-20 relative">
        {/* Background Section */}
        <div className="relative h-72 bg-gray-200">
          {loading ? (
            <Skeleton className="absolute inset-0" height="100%" />
          ) : (
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{
                backgroundImage: `url(${userData.profilepicinfluet2 || 'https://via.placeholder.com/800x300'})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            ></div>
          )}
          {/* Adding a background overlay to darken the image and make text visible */}
          <div className="absolute inset-0 bg-black bg-opacity-40"></div>
        </div>

        {/* Text Section Outside the Background */}
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 z-30 font-bold text-black mt-4 text-3xl w-full">
          <div className="flex justify-between items-center p-1">
            {/* Back Button */}
            <button onClick={handleBackClick} className="text-black "      style={{
          
          marginLeft: isSmallScreen ? '1px' : '89px', // Responsive marginLeft
        }}>
              <ArrowBack /> Back {/* Material-UI Back Arrow Icon */}
            </button>

            {/* Campaign Details Heading */}
            <h1 className="text-xl font-bold text-black ml-auto"    style={{
          
          marginRight: isSmallScreen ? '20px' : '0px', // Responsive marginLeft
        }}>Campaign details</h1>
          </div>
        </div>

        {/* Content Section */}
        <div className="mt-16  px-8 py-12 bg-white rounded-t-2xl shadow-lg z-27"  style={{
          
          marginRight: isSmallScreen ? '20px' : '0px', // Responsive marginLeft
          marginLeft: isSmallScreen ? '0px' : '60px', // Responsive marginLeft
        }}>
          <h1 className="text-4xl font-bold text-gray-800 mb-6">
            {loading ? <Skeleton width="50%" /> : userData.fullname}
          </h1>

          {/* Personal Information with Icons */}
         <p className="mb-4 text-gray-600 flex items-center">
  {loading ? (
    <>
      <Skeleton width={24} height={24} />
      <Skeleton width={80} height={24} />
    </>
  ) : (
    <>
      <Email className="mr-2" />
      <strong>Email:</strong>
      <span className="filter blur-sm cursor-pointer"  onClick={handleClick} >{userData.email || 'No email'}</span>
    </>
  )}
</p>


          <p className="mb-4 text-gray-600 flex items-center">
            {loading ? (
              <>
                <Skeleton width={24} height={24} />
                <Skeleton width={80} height={24} />
              </>
            ) : (
              <>
                <Phone className="mr-2" />
               <span className="filter blur-sm  cursor-pointer"  onClick={handleClick}>{userData.phone || 'No phone'}</span>
              </>
            )}
          </p>

          {/* Influencer Profile Informations */}
          <p className="mb-4 text-gray-600 flex items-center">
            {loading ? (
              <>
                <Skeleton width={24} height={24} />
                <Skeleton width={80} height={24} />
              </>
            ) : (
              <>
                <Category className="mr-2" />
                <strong>Category:</strong> {userData.category || 'No category'}
              </>
            )}
          </p>

          <p className="mb-4 text-gray-600 flex items-center">
            {loading ? (
              <>
                <Skeleton width={24} height={24} />
                <Skeleton width={80} height={24} />
              </>
            ) : (
              <>
                <AttachMoney className="mr-2" />
                <strong>Cost per Segment:</strong> ₹{userData.costingPerSegment || '0'}
              </>
            )}
          </p>

          <p className="mb-4 text-gray-600 flex items-center">
            {loading ? (
              <>
                <Skeleton width={24} height={24} />
                <Skeleton width={80} height={24} />
              </>
            ) : (
              <>
                <Note className="mr-2" />
                <strong>Notes:</strong> {userData.notes || 'No notes provided'}
              </>
            )}
          </p>

          <p className="mb-4 text-gray-600 flex items-center">
            {loading ? (
              <>
                <Skeleton width={24} height={24} />
                <Skeleton width={80} height={24} />
              </>
            ) : (
              <>
                <AccountCircle className="mr-2" />
                <strong>Lifestyle:</strong> {userData.lifestyle || 'No lifestyle'}
              </>
            )}
          </p>

          <p className="mb-4 text-gray-600 flex items-center">
            {loading ? (
              <>
                <Skeleton width={24} height={24} />
                <Skeleton width={80} height={24} />
              </>
            ) : (
              <>
                <AccountCircle className="mr-2" />
                <strong>Commercial:</strong> {userData.commercial || 'No commercial'}
              </>
            )}
          </p>

          {/* Displaying State and Country with icons */}
          <p className="mb-4 text-gray-600 flex items-center">
            {loading ? (
              <>
                <Skeleton width={24} height={24} />
                <Skeleton width={80} height={24} />
              </>
            ) : (
              <>
                <LocationOn className="mr-2" />
                <strong>State:</strong> {userData.state || 'NO'}
              </>
            )}
          </p>

          <p className="mb-4 text-gray-600 flex items-center">
            {loading ? (
              <>
                <Skeleton width={24} height={24} />
                <Skeleton width={80} height={24} />
              </>
            ) : (
              <>
                <LocationOn className="mr-2" />
                <strong>City:</strong> {userData.city || 'NO'}
              </>
            )}
          </p>

          <p className="mb-4 text-gray-600 flex items-center">
            {loading ? (
              <>
                <Skeleton width={24} height={24} />
                <Skeleton width={80} height={24} />
              </>
            ) : (
              <>
                <LocationOn className="mr-2" />
                <strong>Country:</strong> {userData.country || 'NO'}
              </>
            )}
          </p>

          {/* Displaying Followers */}
          <p className="mb-4 text-gray-600 flex items-center">
            {loading ? (
              <>
                <Skeleton width={24} height={24} />
                <Skeleton width={80} height={24} />
              </>
            ) : (
              <>
                <AccountCircle className="mr-2" />
                <strong>Followers:</strong> {userData.followers || '0'}
              </>
            )}
          </p>

          {/* Subscribers */}
          <p className="mb-4 text-gray-600 flex items-center">
            {loading ? (
              <>
                <Skeleton width={24} height={24} />
                <Skeleton width={80} height={24} />
              </>
            ) : (
              <>
                <AccountCircle className="mr-2" />
                <strong>Subscribers:</strong> {userData.subscribers || '0'}
              </>
            )}
          </p>

          {/* Social Media Links */}
          <div className="flex items-center space-x-4 mt-4">
            {loading ? (
              <>
                <Skeleton width={40} height={40} circle />
                <Skeleton width={40} height={40} circle />
                <Skeleton width={40} height={40} circle />
              </>
            ) : (
              <>
                {userData.instagramURL && (
                  <IconButton href={userData.instagramURL} target="_blank" color="primary">
                    <Instagram />
                  </IconButton>
                )}
                {userData.facebookURL && (
                  <IconButton href={userData.facebookURL} target="_blank" color="primary">
                    <Facebook />
                  </IconButton>
                )}
                {userData.youtubeLink && (
                  <IconButton href={userData.youtubeLink} target="_blank" color="error">
                    <YouTube />
                  </IconButton>
                )}
              </>
            )}
          </div>

          {/* Invite Button with Icon */}
          <div className="text-center mt-8">
            {loading ? (
              <Skeleton width={150} height={50} />
            ) : (
              <Button
                variant="contained"
                startIcon={<PersonAdd />}
                onClick={handleInviteClick}
                sx={{
                  background: 'linear-gradient(to bottom right, #7e22ce, #3b82f6)', // Gradient from purple to blue
                  '&:hover': {
                    background: 'linear-gradient(to top left, #7e22ce, #3b82f6)', // Hover effect gradient
                  },
                  color: 'white', // Text color white
                  fontWeight: '600', // Optional: make the text bold
                  borderRadius: '0.375rem', // Optional: rounded corners
                  padding: '0.5rem 1rem', // Padding to match button style
                }}
              >
                Invite
              </Button>
            )}
          </div>
        </div>
      </div>


    {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-xl shadow-xl text-center max-w-sm w-full">
            <h2 className="text-lg font-semibold mb-4">Premium Access Required</h2>
            <p className="text-gray-700">You need premium access to view this detail.</p>
            <button
              onClick={closeModal}
              className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Close
            </button>
          </div>
        </div>
      )}
      {/* Modal for campaigns */}
      {isModalOpen && (
        <CampaignsModal
          userId={userData._id} // Pass userId to CampaignsModal
          onClose={handleCloseModal} // Close modal when needed
        />
      )}
    </div>
  );
};

export default InfluencerDetails3;




// data  with post  and   reels :











// import { AccountCircle, ArrowBack, AttachMoney, Category, Email, Facebook, Instagram, LocationOn, Note, PersonAdd, Phone, YouTube } from '@mui/icons-material';
// import { Button, IconButton, Tab, Tabs } from '@mui/material';
// import React, { useEffect, useState } from 'react';
// import Skeleton from 'react-loading-skeleton'; // Import the Skeleton component
// import 'react-loading-skeleton/dist/skeleton.css'; // Import the styles for the Skeleton
// import { useLocation, useNavigate } from 'react-router-dom';
// import CampaignsModal from './Campaignmodel';
// import Navbar from './Navbar';

// const InfluencerDetails3 = () => {
//   const location = useLocation();
//   const { userData } = location.state || {};
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isSmallScreen, setIsSmallScreen] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [tabIndex, setTabIndex] = useState(0);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setLoading(false);
//     }, 1000); // Show loader for 1 second
//     return () => clearTimeout(timer);
//   }, []);


  
//     // Check screen width for responsiveness
//     useEffect(() => {
//       const handleResize = () => {
//         setIsSmallScreen(window.innerWidth <= 700);
//       };
  
//       handleResize(); // Check initial size
//       window.addEventListener('resize', handleResize);
  
//       return () => {
//         window.removeEventListener('resize', handleResize);
//       };
//     }, []);
//   if (!userData) {
//     return <div>No data found</div>;
//   }

//   const handleInviteClick = () => {
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//   };
  
//   const handleTabChange = (event, newValue) => {
//     setTabIndex(newValue);
//   };

//   const handleBackClick = () => {
//     navigate(-1); // Navigate to the previous screen
//   };

//    // Render media items for posts and reels
//    const renderMediaItems = (mediaArray) => {
//     if (!mediaArray || mediaArray.length === 0) {
//       return <div>No media available</div>;
//     }

//     return mediaArray.map((item, index) => (
//       <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-2">
//         {item.media_type === "IMAGE" ? (
//           <img
//             src={item.media_url}
//             alt={`media-${item.media_id}`}
//             className="w-full rounded-lg shadow-lg"
//           />
//         ) : item.media_type === "VIDEO" ? (
//           <video
//             controls
//             className="w-full rounded-lg shadow-lg"
//             alt={`video-${item.media_id}`}
//           >
//             <source src={item.media_url} type="video/mp4" />
//             Your browser does not support the video tag.
//           </video>
//         ) : (
//           <div>Unsupported media type</div>
//         )}
//         <div className="mt-2 flex justify-between text-sm text-gray-700">
//           <p>Likes: {item.likes}</p>
//           <p>Comments: {item.comments_count}</p>
//         </div>
//       </div>
//     ));
//   };


//   return (
//     <div className="flex h-screen mb-0">
//       {/* Navbar with higher z-index */}
//       <div className="text-white fixed top-0 left-0 bottom-0 z-20">
//         <Navbar />
//       </div>

//       {/* Main content */}
//       <div className="ml-0 w-screen sm:ml-0 h-screen pt-20 relative">
//         {/* Background Section */}
//         <div className="relative h-72 bg-gray-200">
//           {loading ? (
//             <Skeleton className="absolute inset-0" height="100%" />
//           ) : (
//             <div
//               className="absolute inset-0 bg-cover bg-center"
//               style={{
//                 backgroundImage: `url(${userData.profilepicinfluet2 || 'https://via.placeholder.com/800x300'})`,
//                 backgroundSize: 'cover',
//                 backgroundPosition: 'center',
//               }}
//             ></div>
//           )}
//           {/* Adding a background overlay to darken the image and make text visible */}
//           <div className="absolute inset-0 bg-black bg-opacity-40"></div>
//         </div>

//         {/* Text Section Outside the Background */}
//         <div className="absolute top-0 left-1/2 transform -translate-x-1/2 z-30 font-bold text-black mt-4 text-3xl w-full">
//           <div className="flex justify-between items-center p-1">
//             {/* Back Button */}
//             <button onClick={handleBackClick} className="text-black "      style={{
          
//           marginLeft: isSmallScreen ? '1px' : '89px', // Responsive marginLeft
//         }}>
//               <ArrowBack /> Back {/* Material-UI Back Arrow Icon */}
//             </button>

//             {/* Campaign Details Heading */}
//             <h1 className="text-xl font-bold text-black ml-auto"    style={{
          
//           marginRight: isSmallScreen ? '20px' : '0px', // Responsive marginLefts
//         }}>Campaign details</h1>
//           </div>
//         </div>

//         {/* Content Section */}
//         <div className="mt-16  px-8 py-12 bg-white rounded-t-2xl shadow-lg z-27"  style={{
          
//           marginRight: isSmallScreen ? '20px' : '0px', // Responsive marginLeft
//           marginLeft: isSmallScreen ? '0px' : '60px', // Responsive marginLeft
//         }}>
//           <h1 className="text-4xl font-bold text-gray-800 mb-6">
//             {loading ? <Skeleton width="50%" /> : userData.fullname}
//           </h1>

//           {/* Personal Information with Icons */}
//           <p className="mb-4 text-gray-600 flex items-center">
//             {loading ? (
//               <>
//                 <Skeleton width={24} height={24} />
//                 <Skeleton width={80} height={24} />
//               </>
//             ) : (
//               <>
//                 <Email className="mr-2" />
//                 <strong>Email:</strong> {userData.email || 'No  email'}
//               </>
//             )}
//           </p>

//           <p className="mb-4 text-gray-600 flex items-center">
//             {loading ? (
//               <>
//                 <Skeleton width={24} height={24} />
//                 <Skeleton width={80} height={24} />
//               </>
//             ) : (
//               <>
//                 <Phone className="mr-2" />
//                 <strong>Phone:</strong> {userData.phone || 'no contact'}
//               </>
//             )}
//           </p>

//           {/* Influencer Profile Informations */}
//           <p className="mb-4 text-gray-600 flex items-center">
//             {loading ? (
//               <>
//                 <Skeleton width={24} height={24} />
//                 <Skeleton width={80} height={24} />
//               </>
//             ) : (
//               <>
//                 <Category className="mr-2" />
//                 <strong>Category:</strong> {userData.category || 'No category'}
//               </>
//             )}
//           </p>

//           <p className="mb-4 text-gray-600 flex items-center">
//             {loading ? (
//               <>
//                 <Skeleton width={24} height={24} />
//                 <Skeleton width={80} height={24} />
//               </>
//             ) : (
//               <>
//                 <AttachMoney className="mr-2" />
//                 <strong>Cost per Segment:</strong> ₹{userData.costingPerSegment || '0'}
//               </>
//             )}
//           </p>

//           <p className="mb-4 text-gray-600 flex items-center">
//             {loading ? (
//               <>
//                 <Skeleton width={24} height={24} />
//                 <Skeleton width={80} height={24} />
//               </>
//             ) : (
//               <>
//                 <Note className="mr-2" />
//                 <strong>Notes:</strong> {userData.notes || 'No notes provided'}
//               </>
//             )}
//           </p>

//           <p className="mb-4 text-gray-600 flex items-center">
//             {loading ? (
//               <>
//                 <Skeleton width={24} height={24} />
//                 <Skeleton width={80} height={24} />
//               </>
//             ) : (
//               <>
//                 <AccountCircle className="mr-2" />
//                 <strong>Lifestyle:</strong> {userData.lifestyle || 'No lifestyle'}
//               </>
//             )}
//           </p>

//           <p className="mb-4 text-gray-600 flex items-center">
//             {loading ? (
//               <>
//                 <Skeleton width={24} height={24} />
//                 <Skeleton width={80} height={24} />
//               </>
//             ) : (
//               <>
//                 <AccountCircle className="mr-2" />
//                 <strong>Commercial:</strong> {userData.commercial || 'No commercial'}
//               </>
//             )}
//           </p>

//           {/* Displaying State and Country with icons */}
//           <p className="mb-4 text-gray-600 flex items-center">
//             {loading ? (
//               <>
//                 <Skeleton width={24} height={24} />
//                 <Skeleton width={80} height={24} />
//               </>
//             ) : (
//               <>
//                 <LocationOn className="mr-2" />
//                 <strong>State:</strong> {userData.state || 'NO'}
//               </>
//             )}
//           </p>

//           <p className="mb-4 text-gray-600 flex items-center">
//             {loading ? (
//               <>
//                 <Skeleton width={24} height={24} />
//                 <Skeleton width={80} height={24} />
//               </>
//             ) : (
//               <>
//                 <LocationOn className="mr-2" />
//                 <strong>City:</strong> {userData.city || 'NO'}
//               </>
//             )}
//           </p>

//           <p className="mb-4 text-gray-600 flex items-center">
//             {loading ? (
//               <>
//                 <Skeleton width={24} height={24} />
//                 <Skeleton width={80} height={24} />
//               </>
//             ) : (
//               <>
//                 <LocationOn className="mr-2" />
//                 <strong>Country:</strong> {userData.country || 'NO'}
//               </>
//             )}
//           </p>

//           {/* Displaying Followers */}
//           <p className="mb-4 text-gray-600 flex items-center">
//             {loading ? (
//               <>
//                 <Skeleton width={24} height={24} />
//                 <Skeleton width={80} height={24} />
//               </>
//             ) : (
//               <>
//                 <AccountCircle className="mr-2" />
//                 <strong>Followers:</strong> {userData.followers || '0'}
//               </>
//             )}
//           </p>

//           {/* Subscribers */}
//           <p className="mb-4 text-gray-600 flex items-center">
//             {loading ? (
//               <>
//                 <Skeleton width={24} height={24} />
//                 <Skeleton width={80} height={24} />
//               </>
//             ) : (
//               <>
//                 <AccountCircle className="mr-2" />
//                 <strong>Subscribers:</strong> {userData.subscribers || '0'}
//               </>
//             )}
//           </p>

//           {/* Social Media Links */}
//           <div className="flex items-center space-x-4 mt-4">
//             {loading ? (
//               <>
//                 <Skeleton width={40} height={40} circle />
//                 <Skeleton width={40} height={40} circle />
//                 <Skeleton width={40} height={40} circle />
//               </>
//             ) : (
//               <>
//                 {userData.instagramURL && (
//                   <IconButton href={userData.instagramURL} target="_blank" color="primary">
//                     <Instagram />
//                   </IconButton>
//                 )}
//                 {userData.facebookURL && (
//                   <IconButton href={userData.facebookURL} target="_blank" color="primary">
//                     <Facebook />
//                   </IconButton>
//                 )}
//                 {userData.youtubeLink && (
//                   <IconButton href={userData.youtubeLink} target="_blank" color="error">
//                     <YouTube />
//                   </IconButton>
//                 )}
//               </>
//             )}
//           </div>



//   {/* Center the tabs */}
//   <div className="mt-16 px-8 py-12 bg-white rounded-t-2xl shadow-lg">
//           <Tabs 
//             value={tabIndex} 
//             onChange={handleTabChange} 
//             aria-label="media tabs" 
//             centered
//           >
//             <Tab label="Posts" />
//             <Tab label="Reels" />
//           </Tabs>

//           <div className="tab-content mt-4">
//             {/* Show Posts */}
//             {tabIndex === 0 && (
//               <div className="flex flex-wrap justify-start ml-12">
//                 {loading ? (
//                   <Skeleton count={5} height={150} />
//                 ) : (
//                   renderMediaItems(userData.posts || []) 
//                 )}
//               </div>
//             )}

//             {/* Show Reels */}
//             {tabIndex === 1 && (
//               <div className="flex flex-wrap justify-start ml-12">
//                 {loading ? (
//                   <Skeleton count={5} height={150} />
//                 ) : (
//                   renderMediaItems(userData.reels || [])
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//           {/* Invite Button with Icon */}
//           <div className="text-center mt-8">
//             {loading ? (
//               <Skeleton width={150} height={50} />
//             ) : (
//               <Button
//                 variant="contained"
//                 startIcon={<PersonAdd />}
//                 onClick={handleInviteClick}
//                 sx={{
//                   background: 'linear-gradient(to bottom right, #7e22ce, #3b82f6)', // Gradient from purple to blue
//                   '&:hover': {
//                     background: 'linear-gradient(to top left, #7e22ce, #3b82f6)', // Hover effect gradient
//                   },
//                   color: 'white', // Text color white
//                   fontWeight: '600', // Optional: make the text bold
//                   borderRadius: '0.375rem', // Optional: rounded corners
//                   padding: '0.5rem 1rem', // Padding to match button style
//                 }}
//               >
//                 Invite
//               </Button>
//             )}
//           </div>
//         </div>



//       </div>

//       {/* Modal for campaigns */}
//       {isModalOpen && (
//         <CampaignsModal
//           userId={userData._id} // Pass userId to CampaignsModal
//           onClose={handleCloseModal} // Close modal when needed
//         />
//       )}
//     </div>
//   );
// };

// export default InfluencerDetails3;
